module.exports = __webpack_public_path__ + "img/samsung-bk.b8f67b22.svg";